// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";
import PropTypes from "prop-types";

import {
  createTheme,
  ThemeProvider as MuiThemeProvider,
} from "@mui/material/styles";
import { ptBR } from "@mui/material/locale";

import variants from "./variants";

/**
 * Our ThemeProvider functions the same as MaterialUI's, but
 * we keep all themes in Goban. When changes or new themes are
 * needed, they should happen in here.
 */
const ThemeProvider = ({ children, theme }) => {
  const muiTheme = createTheme(variants.get(theme), ptBR);
  return <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>;
};

ThemeProvider.defaultProps = {
  theme: variants.default,
};

ThemeProvider.propTypes = {
  theme: PropTypes.oneOf(variants.keys),
  children: PropTypes.node.isRequired,
};

export default ThemeProvider;
